import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { track } from './composables/telemetry';
import { initAppKit } from './lib/appkit';
// Register Lottie web components globally
import '@lottiefiles/lottie-player'; // JSON-based animations
import '@dotlottie/player-component'; // .lottie container animations

initAppKit();
const app = createApp(App).use(createPinia()).use(router);

router.afterEach((to) => {
  track('pageview', { path: to.fullPath });
});

app.mount('#app');
